import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { UnitProvider } from './../../../../providers/unit/unit';

@IonicPage()
@Component({
  selector: 'page-configuration-unit-edit',
  templateUrl: 'configuration-unit-edit.html',
})
export class ConfigurationUnitEditPage {
  public formData: FormGroup;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private translateSvc: TranslateService,
    private unitPrvdr: UnitProvider
  ) {
    this.formData = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required])],
      short: ['', Validators.compose([Validators.required])],
      code: ['', Validators.compose([Validators.required])],
    });
  }

  ionViewDidLoad() {
    this.formData.setValue({
      name: this.navParams.data.name,
      short: this.navParams.data.short,
      code: this.navParams.data.code,
    });
  }

  onEditData() {
    let loading = this.loadingCtrl.create({
      spinner: 'dots',
      content: this.translateSvc.instant('Editing MPP Unit...'),
      duration: 3000,
    });
    loading.present();

    let data = {
      id: this.navParams.data._id,
      name: this.formData.value.name,
      short: this.formData.value.short,
      code: this.formData.value.code,
    };

    this.unitPrvdr.edit(data).subscribe(
      (res: any) => {
        loading.dismiss();
        if (res.success === true) {
          this.showToast(this.translateSvc.instant('MPP Unit edited succesfully.'));
          this.navCtrl.pop();
        } else {
          this.showToast('ERROR: ' + res.message);
        }
      },
      (error) => {
        loading.dismiss();
        this.showToast('ERROR: ' + error.error.message);
      }
    );
  }

  onCancel() {
    this.navCtrl.pop();
  }

  private showToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top',
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-unit/configuration-unit-edit/configuration-unit-edit.ts